<div class="row">
  <div class="col-md-12">
    <h5>Configurações da Triagem</h5>
    <p *ngIf="triagemItem" class="text-muted">
      <strong>Título:</strong> {{ triagemItem.titulo }}
    </p>
    <p *ngIf="triagemItem" class="text-muted">
      <strong>ID:</strong> {{ triagemItem.iD_TRIAGEM }}
    </p>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <h6 class="mt-3 mb-2">Tipos de Classificação</h6>
    <div *ngIf="arrayTipoClassificacao && arrayTipoClassificacao.length > 0" class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th>Descrição</th>
            <th class="text-center">Quantidade</th>
            <th class="text-center">Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of arrayTipoClassificacao">
            <td>{{ item.descricao }}</td>
            <td class="text-center">{{ item.qtd }}</td>
            <td class="text-center">
              <input type="number" class="form-control form-control-sm text-center" 
                [(ngModel)]="item.valor" 
                [ngModelOptions]="{standalone: true}"
                placeholder="0" 
                style="min-width: 80px; max-width: 120px;">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="!arrayTipoClassificacao || arrayTipoClassificacao.length === 0" class="alert alert-info">
      <i class="feather icon-info"></i>
      Nenhum tipo de classificação encontrado para esta triagem.
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-6 text-left">
    <br>
    <button type="button" class="btn btn-danger" (click)="voltar()">
      <i class="fa fa-chevron-circle-left"></i>
      Voltar
    </button>
  </div>
  <div class="col-md-6 text-right">
    <br>
    <button type="button" class="btn btn-primary" (click)="salvar()">
      <i class="feather icon-check-circle"></i>
      Salvar
    </button>
  </div>
</div>
